// src/pages/Warehouse/ProductTypes/ProductTypes.jsx
import { Col, Row } from "antd"
import React from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { InsertRowRightOutlined } from "@ant-design/icons"
import AddProductTypeDrawer from "./AddProductTypeDrawer"
import ProductTypesTable from "./ProductTypesTable"

export default function ProductTypes() {
  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader text="Product Types Management" icon={<InsertRowRightOutlined />} />
        </Col>

        <Col span={24}>
          <AddProductTypeDrawer />
        </Col>

        <Col span={24}>
          <ProductTypesTable />
        </Col>
      </Row>
    </div>
  )
}
